import axios from 'axios';
import {setAlert} from './alertAction';
import {
    deleteAccountRoute,
    loadUserRoute,
    loginRoute,
    registerRoute,
    updateUserProfileRoute
} from "../../utils/apiRoutes";
import {
    ACCOUNT_DELETED,
    AUTH_ERROR,
    LOGIN_FAIL,
    LOGIN_SUCCESS,
    LOGOUT,
    REGISTER_FAIL,
    REGISTER_SUCCESS,
    UPDATE_USER_PROFILE,
    USER_LOADED
} from './typesAction';
import setAuthToken from '../../utils/setAuthToken';
import {connectRealtime, disconnectRealtime} from "../../utils/realtime";

// Load User
export const loadUser = () => async (dispatch) => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);

        try {
            const res = await axios.get(loadUserRoute);

            const user = res.data;
            const socket = {current: connectRealtime(localStorage.token)}
            socket.current.emit("add-user", user.id)

            dispatch({
                type: USER_LOADED,
                payload: {user, socket},
            });
        } catch (err) {
            dispatch({
                type: AUTH_ERROR,
            });
        }
    }
};

// Register User
export const register =
    ({name, email, password}) =>
        async (dispatch) => {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                },
            };

            const body = JSON.stringify({name, email, password});

            try {
                const res = await axios.post(registerRoute, body, config);

                if (!res.data)
                    return;

                dispatch({
                    type: REGISTER_SUCCESS,
                    payload: res.data,
                });

                dispatch(loadUser());
            } catch (err) {
                const errors = err.response.data.errors;

                if (errors) {
                    errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
                }
                dispatch({
                    type: REGISTER_FAIL,
                });
            }
        };

// Login User
export const login = (email, password) => async (dispatch) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    const body = JSON.stringify({email, password});

    try {
        const res = await axios.post(loginRoute, body, config);

        if (!res.data)
            return;

        dispatch({
            type: LOGIN_SUCCESS,
            payload: res.data,
        });

        dispatch(loadUser());
    } catch (err) {
        const errors = err.response.data.errors;

        if (errors) {
            errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
        }
        dispatch({
            type: LOGIN_FAIL,
        });
    }
};

// Logout / Clear Profile
export const logout = () => (dispatch) => {
    disconnectRealtime();
    dispatch({type: LOGOUT});
};

// Delete account
export const deleteAccount = () => async (dispatch) => {
    if (window.confirm('Are you sure? This can NOT be undone!')) {
        try {
            await axios.delete(deleteAccountRoute);

            disconnectRealtime();
            dispatch({type: ACCOUNT_DELETED});

            dispatch(setAlert('Your account has been permanently deleted', 'success'));
        } catch (err) {
            dispatch({
                type: ACCOUNT_DELETED,
                payload: {msg: err.response.statusText, status: err.response.status},
            });
        }
    }
};

export const updateProfile = (profile) =>
    async (dispatch) => {
        const {status, name, phone, birthDate, location, avatarImage} = profile;
        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        };

        const body = JSON.stringify({status, name, phone, birthDate, location, avatarImage});

        try {
            const res = await axios.post(updateUserProfileRoute, body, config);

            dispatch({
                type: UPDATE_USER_PROFILE,
                payload: res.data,
            });

            dispatch(setAlert('Profile updated', 'success'));
        } catch (err) {
            const errors = err.response.data.errors;

            if (errors) {
                errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
            }
        }
    };
